import React from "react";

import Pagetrans from "./pagetrans";
import work from "../svg/work.4234d723.svg";
import education from "../svg/education.5e6aebc1.svg";

const Aboutpage = () => {
  return (
    <main className="about py-lg-5 titled-section trans ">
      <Pagetrans className="container py-lg-3 py-xl-5">
        <h1 className="section-title text-uppercase">
          About <span className="decorate">Me</span>{" "}
          <span className="bg text-uppercase d-none d-md-block">resume</span>
        </h1>
        <section className="section personal-section">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="title text-uppercase text-light">
                personal infos
              </h2>
              <div
                className="image home-image d-md-none prf-image"
                style={{ position: "relative", overflow: "hidden" }}
              ></div>
              <div className="row details">
                <div className="col-6">
                  <p>
                    <span className="key">first name</span>{" "}
                    <span className="data">Emmanuel</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">address</span>{" "}
                    <span className="data">Abuja, Nigeria</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">last name</span>{" "}
                    <span className="data">Menyaga</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">phone</span>{" "}
                    <span className="data">+2348162452124</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">age</span>{" "}
                    <span className="data">21 Years</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">nationality</span>{" "}
                    <span className="data">Nigerian</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">availabilty</span>{" "}
                    <span className="data">Available</span>
                  </p>
                </div>
                <div className="col-6">
                  <p>
                    <span className="key">languages</span>{" "}
                    <span className="data">English, Igala</span>
                  </p>
                </div>
                <div className="col-12 mt-3">
                  <a
                    href="#download-cv"
                    disabled=""
                    className="btn btn-primary text-uppercase text-bold disabled"
                  >
                    Download cv
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="row cards">
                <div className="col-6">
                  <div>
                    <p>2</p>
                    <p>years of experience</p>
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <p>10</p>
                    <p>completed projects</p>
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <p>5</p>
                    <p>happy customers</p>
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <p>2</p>
                    <p>internships completed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr className="separator" />
        <section className="section skill-section">
          <h2 className="title text-uppercase text-light text-md-center text-left">
            skills
          </h2>
          <div className="row">
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-99">
                <span>99</span>
              </div>
              <p className="text-center">HTML</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-90">
                <span>90</span>
              </div>
              <p className="text-center">JavaScript</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-90">
                <span>90</span>
              </div>
              <p className="text-center">CSS</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-66">
                <span>66</span>
              </div>
              <p className="text-center">PHP</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-80">
                <span>80</span>
              </div>
              <p className="text-center">NodeJs</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-89">
                <span>89</span>
              </div>
              <p className="text-center">React</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-89">
                <span>89</span>
              </div>
              <p className="text-center">Express</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-66">
                <span>66</span>
              </div>
              <p className="text-center">MongoDB</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-66">
                <span>66</span>
              </div>
              <p className="text-center">Figma</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-95">
                <span>95</span>
              </div>
              <p className="text-center">Heroku</p>
            </div>
            <div
              className="col-md-3 col-6 d-flex"
              style={{ flexFlow: "column nowrap" }}
            >
              <div className="progress-circle mx-auto progress-90">
                <span>90</span>
              </div>
              <p className="text-center">Netlify</p>
            </div>
          </div>
        </section>
        <hr className="separator" />
        <section className="section skill-section">
          <h2 className="title text-uppercase text-light text-left text-md-center">
            experience &amp; education
          </h2>
          <div className="row">
            <div className="col-lg-6 work">
              <div>
                <span className="icon">
                  <img src={education} alt="education icon" />
                </span>
                <h1 className="work-title">
                  <span>bachelor degree</span>{" "}
                  <span className="company-date">
                    <span>Kogi State University, Anyigba</span>{" "}
                    <span>2016 - 2019</span>
                  </span>
                </h1>
                <p>
                  Graduated with an honor in Mathematics and Education (B.Sc.
                  Ed.) from Kogi State University, Anyigba, Kogi State, Nigeria
                </p>
              </div>
            </div>
            <div className="col-lg-6 work">
              <div>
                <span className="icon">
                  <img src={work} alt="work icon" />
                </span>
                <h1 className="work-title">
                  <span>back-end developer</span>{" "}
                  <span className="company-date">
                    <span>HNG Internship</span> <span>2020</span>
                  </span>
                </h1>
                <p>
                  Participated in the internship as a back-end developer and
                  made it to finalist by constantly working to deliver working
                  services that ease life for everyday users and developers
                  alike.
                </p>
              </div>
            </div>
          </div>
        </section>
      </Pagetrans>
    </main>
  );
};

export default Aboutpage;
